import React, { Component } from "react";
import styled from "styled-components";
import Helmet from "react-helmet";
import Link from "gatsby-link";
import config from "../../data/SiteConfig";

class ContactPage extends Component {
  render() {
    return (
      <div className="contact">
        <Helmet title={`Contact | ${config.siteTitle}`} />
        <ContactPageContainer>
          <PageHead>
            <h1>Contact Us</h1>
            <h3>We're looking forward to working with you.</h3>
          </PageHead>
          <PageDivider />
          <ContactBody>
            <div className="Left">
              <p>
                The best way to see if AppTree is the right fit for you is to
                see it in action.
              </p>
              <p>
                We are on a mission to make enterprise software easier to build,
                deploy and support and we are looking for the best people to
                join us. Let us know if you are interested.
              </p>
            </div>
            <div className="Right">
              <div className="contact-item">
                <h4>AppTree Support</h4>
                <a href="mailto:support@apptreesoftware.com">
                  support@apptreesoftware.com
                </a>
              </div>
              <div className="contact-item">
                <h4>Sales</h4>
                <a href="mailto:sales@apptreesoftware.com">
                  sales@apptreesoftware.com
                </a>
                <p>888-680-8240</p>
              </div>
            </div>
          </ContactBody>
        </ContactPageContainer>
      </div>
    );
  }
}

const ContactPageContainer = styled.div`
  width: 800px;
  margin: 0 auto 200px;

  @media screen and (max-width: 768px) {
    width: 90%;
    margin: 0 auto 50px;
  }
`;

const PageHead = styled.div`
  margin: 50px auto;
  text-align: center;
  h1,
  h3 {
    margin: auto;
  }
  h1 {
    width: 80%;
  }
  h3 {
    width: 85%;
  }
`;

const ContactBody = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;

  @media screen and (max-width: 768px) {
    display: flex;
    flex-flow: column;
  }

  .Left {
    display: flex;
    flex-flow: column;
    justify-content: space-between;
  }

  .Left > p {
    margin: 20px 0;
    padding-right: 50px;
  }

  .Right {
    h4 {
      margin-bottom: 10px;
    }
    padding-left: 50px;
    .contact-item {
      margin: 20px 0;
    }

    @media screen and (max-width: 768px) {
      border: none;
      padding: 0;
    }
  }

  a {
    margin-right: 20px;
    font-size: 1.6rem;
    background: rgba(67, 171, 96, 0.3);
    border-bottom: 4px solid rgba(67, 171, 96, 0.8);
    transition: all 0.3s ease;
    padding: 3px 3px 0 3px;
  }
  a:hover {
    background: rgba(67, 171, 96, 0.8);
  }
`;

const PageDivider = styled.div`
  border-bottom: 0.5px solid black;
  width: 60%;
  margin: 50px auto;
`;

export default ContactPage;



// WEBPACK FOOTER //
// ./src/pages/contact.jsx